export default  {
  bindings: {
    order: '=',
    formTab: '=',
    orderStatuses: '<',
    paymentStatuses: '<'
  },
  controller: 'orderSummaryController',
  template: require('../views/order.summary.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/order.summary.component.js